module.exports = __webpack_public_path__ + "static/media/return.fff3852a.svg";